<!--法院公告-->
<template>
  <div class="court-container">
    <header-index/>
    <div class="court-content">
      <div class="court-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/ServiceCentre/serviceCloud?pName='+cityList.abridge+'企服务云' }">
            {{ cityList.abridge }}企服务云
          </el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/enterpriseSearch/index' }">企业查询</el-breadcrumb-item>
          <el-breadcrumb-item>法院公告</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="court-top">
        <p class="court-title">查询法院公告</p>
        <el-input placeholder="请输入企业名称" v-model="keyword" class="input-with-select" style="width: 45%;"
                  @keyup.enter.native="gteCourtInfo">
          <el-button type="danger" slot="append" @click="gteCourtInfo">查一下</el-button>
        </el-input>
      </div>
      <div class="court-info">
        <div class="court-search-menu">
          <span>最新法院公告</span>
          <el-date-picker v-model="year" value-format="yyyy" type="year" placeholder="年份" style="width: 170px"/>
        </div>
        <div class="court-list">
          <div v-for="info of courtInfo" class="court-list-item" @click="courtDetails(info)">
            <p class="court-small-title">{{ info.court }}</p>
            <p>
              <span class="court-gray">公告类型：</span>
              <span class="court-black">{{ info.announcement_type }}</span>
              <span class="court-gray">公告人：</span>
              <span class="court-black">{{ info.company_name }}</span>
              <span class="court-gray">刊登日期：</span>
              <span class="court-black">{{ formatDate(info.publication_date) }}</span>
            </p>
          </div>
        </div>
        <page :total="tablePage.total" class="pagination" @currentPage="currentPage" :page="tablePage.currentPage"
              :limit="tablePage.pageSize" style="padding: 0px 25px 15px 10px;"/>
      </div>
    </div>
    <home_footer/>
    <Hang/>
    <!--法院公告详情-->
    <el-dialog title="法院公告详情" :visible.sync="dialogVisible">
      <el-descriptions class="margin-top" :column="1" border>
        <el-descriptions-item>
          <template slot="label">刊登日期</template>
          {{ $moment(courtDetail.publicationDate).format('YYYY-MM-DD') || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">刊登版面</template>
          {{ courtDetail.publicationPage || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">案件身份</template>
          {{ courtDetail.party || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">公告类型</template>
          {{ courtDetail.announcementType || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">法院</template>
          {{ courtDetail.court || '-' }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template slot="label">法院公告内容</template>
          <div v-html="courtDetail.detail" v-if="courtDetail.detail"></div>
          <span v-else>-</span>
        </el-descriptions-item>
      </el-descriptions>
    </el-dialog>
  </div>
</template>

<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import cityJson from "@/static/cityJson.json";
import page from "@/components/page/pages";
import {searchDdCourtDeclared,} from '@/api/enterprise_searchApi'
import {ddCourtDeclaredDetails} from '@/api/enterpriseDetailsApi'
export default {
  name: "court",
  components: {Hang, Home_footer, HeaderIndex, page},
  data() {
    return {
      keyword: '',
      cid: 0,
      cityList: {},
      year: '',
      courtInfo: [],
      tablePage: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },
      courtDetail:{},
      dialogVisible:false,
    }
  },
  watch: {
    year(newVal, oldVal) {
      if (newVal != oldVal) {
        this.gteCourtInfo();
      }
    },
  },
  methods: {
    /*获取法院公告*/
    gteCourtInfo() {
      searchDdCourtDeclared({
        keyword: this.keyword,
        page: this.tablePage.currentPage,
        request: 'form',
        year: this.year,
      }).then(res => {
        if (res.code == 200) {
          this.tablePage.total = parseInt(res.content.total);
          this.courtInfo = res.content.rows;
          console.log(res);
        }
      })
    },
    //切换分页
    currentPage(page) {
      this.tablePage.currentPage = page;
      this.gteCourtInfo();
    },
    /*时间格式化处理*/
    formatDate(date) {
        let dt = new Date(date)
        let yyyy = dt.getFullYear()
        let MM = (dt.getMonth() + 1).toString().padStart(2, '0')
        let dd = dt.getDate().toString().padStart(2, '0')
        return yyyy + '-' + MM + '-' + dd
    },
    /*法院公告*/
    courtDetails(info){
      ddCourtDeclaredDetails({id:info.id,request:'form'}).then(res=>{
        if (res.code==200){
          console.log(res.content);
          this.courtDetail=res.content;
          this.dialogVisible=true;
        }
      })
    }
  },
  mounted() {
    this.gteCourtInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    if (sessionStorage.getItem('setPositioning')) {
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    } else {
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name) {
          this.cityList = li;
        }
      }
    }
  }
}
</script>
<style scoped>
.court-container >>> .court-content .court-top .el-input__inner {
  background-color: #ffffff;
  border-radius: 6px 0px 0px 6px;
  border: 1px solid #DDDDDD;
  color: #333333;
  font-size: 16px;
  height: 55px;
  line-height: 55px;
  padding: 0 20px;
  border-right: none;
}
.court-container >>> .court-content .court-top input::-webkit-input-placeholder {
  color: #333333;
}
.court-container >>> .court-content .court-top .el-input__suffix {
  display: flex;
  align-items: center;
  right: 10px;
}
.court-container >>> .court-content .court-top .el-icon-search {
  font-size: 19px;
}
.court-container >>> .court-content .court-top .el-input-group__append, .el-input-group__prepend {
  background-color: #FE273B;
  color: #fff;
  border: 1px solid #FE273B;
  border-radius: 0px 6px 6px 0px;
  padding: 0 20px;
}
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__separator[class*=icon] {
  margin: 0 0px;
  font-family: 'SourceHanSansCN';
  color: #666666;
}
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner,
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb {
  font-size: 14px;
  line-height: normal;
}
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__inner a,
.court-container >>> .court-content .court-breadcrumb .el-breadcrumb__inner.is-link {
  font-weight: 100;
  color: #666666;
  font-family: 'SourceHanSansCN';
}
.court-container >>> .court-content .court-info .court-search-menu input::-webkit-input-placeholder {
  color: #333333;
}
.court-container >>> .el-descriptions-item__label.is-bordered-label {
  color: #333333;
  background: #D6E9FF;
  width: 160px;
}
.court-container >>> .el-descriptions .is-bordered .el-descriptions-item__cell {
  border: 1px solid #D0E0F2;
  padding: 12px 10px;
  font-size: 14px;
  color: #333333;
}
.court-container >>> .el-descriptions__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.court-container >>> .el-descriptions__title {
  font-size: 16px;
  font-weight: 100;
  font-family: 'SourceHanSansCN';
}
.court-container >>> .el-descriptions-item__content {
  min-width: 305px;
}
</style>
<style scoped lang="scss">
.court-container {
  background: #E7E9F5;

  .court-content {
    .court-breadcrumb {
      padding: 10px 18%;
      min-width: 76rem;
      background: #E7E9F5;
    }

    .court-top {
      background: url("~@/assets/img/enterprise/enterprise_search.png") no-repeat;
      height: 300px;
      min-width: 76rem;
      background-size: 100% 100%;
      text-align: center;
      padding: 0px 18%;
      .court-title {
        color: #ffffff;
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        cursor: pointer;
        margin-block-start: 0px;
        margin-block-end: 0px;
        padding: 70px 0px 50px;
        font-weight: bold;
      }
    }

    .court-info {
      margin: 20px 18%;
      background: #FFFFFF;
      padding: 15px 0px;
      min-width: 76rem;
      .court-search-menu {
        display: flex;
        justify-content: space-between;
        border-bottom: 1px solid #E7E9F5;
        align-items: center;
        padding-bottom: 15px;
        padding-left: 20px;
        padding-right: 20px;

        span {
          font-size: 14px;
          font-family: 'SourceHanSansCN';
          color: #333333;
        }
      }

      .court-list {
        .court-list-item {
          border-bottom: 1px solid #E7E9F5;
          padding: 20px;

          .court-small-title {
            font-size: 18px;
            font-family: 'SourceHanSansCN';
            color: #333333;
            padding-bottom: 15px;
          }

          .court-gray {
            color: #666666;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
          }

          .court-black {
            color: #333333;
            font-size: 14px;
            font-family: 'SourceHanSansCN';
            padding-right: 80px;
          }

          p {
            margin-block-end: 0px;
            margin-block-start: 0px;
            padding-bottom: 5px;
          }
        }
      }
    }
  }
}
</style>